import { useEffect } from 'react';
import analytics from '../utils/analytics';

export interface ContentViewedAnalyticsParams {
    /** The type/container of the content being viewed */
    eventContainer: string;
    /** The ID of the content entry */
    entryId: string;
    /** The URL of the content entry */
    entryUrl: string;
    /** The type of parent page (e.g., 'topic-set', 'collection', 'kb-home') */
    parentPageType: string;
    /** The URL of the parent page */
    parentPageUrl: string;
}

/**
 * Hook to track content viewed analytics events for BWAV-2192
 *
 * This hook automatically tracks when content is viewed and can be used
 * across different content types (topics, kb-articles, etc.)
 *
 * @param params - The analytics parameters for tracking content views
 */
export const useContentViewedAnalytics = (
    params: ContentViewedAnalyticsParams
): void => {
    const { eventContainer, entryId, entryUrl, parentPageType, parentPageUrl } =
        params;

    useEffect(() => {
        analytics.trackEvent('content viewed', {
            eventContainer,
            event: 'viewed',
            eventComponent: 'content',
            parent_page_type: parentPageType,
            parent_page_url: parentPageUrl,
            view_format: 'page'
        });
    }, [eventContainer, entryId, entryUrl, parentPageType, parentPageUrl]);
};
